import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const isAuthenticated = () =>{
  // Tua lógica de autenticação vem aqui!
  let token = localStorage.getItem("token");
  if(token){
    let jwtPayload = jwtDecode(token);
    console.log(jwtPayload['roles'])
  }
  return localStorage.getItem("token") !== null
}
const PrivateRoute = () =>{
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />
}
export default PrivateRoute